module.exports = __webpack_public_path__ + "img/order-in-progress.77dc8da6.png";